import { render, staticRenderFns } from "./card-context-translations.vue?vue&type=template&id=f8540288&"
import script from "./card-context-translations.vue?vue&type=script&lang=js&"
export * from "./card-context-translations.vue?vue&type=script&lang=js&"
import style0 from "./card-context-translations.vue?vue&type=style&index=0&id=f8540288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports